import { Component, Input } from '@angular/core';
import { CardItem } from '../../models/card.model';
import { IconService } from '../../services/icon.service';
import { UIIconsEnum } from '../../enums/icons.enum';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input() card!: CardItem

  constructor(private iconService: IconService) {}

  getIcon(name: keyof typeof UIIconsEnum) {
    return this.iconService.getUIIconByName(name);
  }
}
